import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchJobLeaves } from "services/job-leave.service";
import { JobLeave } from "types/JobLeave";
import { AppDispatch } from "configureStore";

interface JobLeavesState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: JobLeave[];
  filtersValue: Record<string, unknown>;
}

const initialState: JobLeavesState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
  filtersValue: {},
};

const JobLeavesSlice = createSlice({
  name: "jobLeaves",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<{ error: string }>) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state, action: PayloadAction<JobLeave[]>) {
      state.collection = Array.isArray(action.payload) ? action.payload : [];
      state.isLoading = false;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
});

const { actions, reducer } = JobLeavesSlice;

export const { setDestroy, setLoading, setError, setData, setFilterValue } =
  actions;
export default reducer;

export const fetchJobLeavesThunk =
  (companyId: string, filtersValue: Record<string, unknown> = {}) =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const data = await fetchJobLeaves(companyId, filtersValue);
      dispatch(setData(data));
    } catch (e) {
      dispatch(setError({ error: "not_fetch" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
